import { FiChevronRight } from "react-icons/fi";

export default function CatalogCategoryList({ categories = [], onOpen }) {
  if (!categories.length) return null;

  return (
    <div className="csList">
      {categories.map((c, index) => (
        <button
  key={c.id}
  type="button"
  className="csRow"
  style={{
    animationDelay: `${Math.min(index, 8) * 45}ms`,
  }}
  onClick={() => onOpen?.(c)}
>
          <div className="csRowText">
            <div className="csRowTitle">{c.title}</div>
          </div>
          <FiChevronRight className="csChevron" />
        </button>
      ))}
    </div>
  );
}